module.exports = __webpack_public_path__ + "static/media/material_symbols.c961488d.svg";